import { createFeatureSelector, createSelector } from '@ngrx/store'
import { CuisinesState, featureCuisineName } from './cuisine.state'

const getCuisinesFeatureState = createFeatureSelector<CuisinesState>(featureCuisineName)

export const getCuisines = createSelector(getCuisinesFeatureState, state => state.cuisines)
export const getSelectedCuisines = createSelector(getCuisinesFeatureState, state => state.selectedCuisines)
export const getErrorCuisine = createSelector(getCuisinesFeatureState, state => state.error)
export const getStatusCuisine = createSelector(getCuisinesFeatureState, state => state.status)
